export type ExportLevel = "DUB" | "FILE";

export enum ExportMediaSource {
  ORIGINAL = "ORIGINAL",
  DUBBED = "DUBBED"
}

export interface ExportConfig {
  exportAs: string;
  format: string;
  burnSubtitlesToVideo: boolean;
  includePauseInSubtitles: boolean;
  exportLevel: ExportLevel;
  rate?: string;
  prores: boolean;
  mediaSource: ExportMediaSource;
  subtitleSource?: ExportMediaSource;
  includeOriginalSubtitle?: boolean;
  includeTranslatedSubtitle?: boolean;
}
